import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import TotalOverheadBudgetInputContainer from '../../containers/total-overhead-budget-input/TotalOverheadBudgetInputContainer';

const TotalOverheadBudgetInputPage = () => {
  return (
    <>
      <BreadcrumbsContainer
        title="판관비 관리/전체 간접비 관리"
        icon="budget"
      />
      <TotalOverheadBudgetInputContainer />
    </>
  );
};

export default TotalOverheadBudgetInputPage;
